const duelReducer = (state = [], action) => {
  switch (action.type) {
    case "FETCH_DUEL":
      return action.payload;
    default:
      return state;
  }
};

export default duelReducer;
